import React, { useEffect, useState } from "react";
import { CAColumnConfigModal } from "./ColumnConfig";
import FilterStep from "./ColumnFilters";
import { CA_RECOMMENDATION_ELEMENTS } from "../../constants";

const CAColumnConfigModalStepper = props => {
    const [step, setStep] = useState(1);
    const [hasStepper, setHasStepper] = useState(true);

    useEffect(() => {
        if (
            !CA_RECOMMENDATION_ELEMENTS.some(elem => props?.selectedElements?.column?.includes(elem.key) && elem?.hasFilter) &&
            !props.selectedElements.column.includes("recomtype")
        ) {
            setHasStepper(false);
            setStep(2);
        }
    }, [props.selectedElements]);

    return (
        <div>
            {step === 1 && hasStepper ? (
                <FilterStep {...props} onNext={() => setStep(2)} />
            ) : (
                <CAColumnConfigModal {...props} hasStepper={hasStepper} onBack={() => setStep(1)} />
            )}
        </div>
    );
};

export default CAColumnConfigModalStepper;
